import React, { useState } from "react"
import "./styles.scss"
import UpgradePlanModal, { User, URLs } from "app/components/upgrade_plan_modal"

interface Props {
  user: User
  urls: URLs
}

const HolidayBanner = ({ user, urls }: Props) => {
  const [showModal, setShowModal] = useState(false)

  return (
    <>
      <UpgradePlanModal
        initialPromoCode="TECHTHEHALLS23"
        onClose={() => setShowModal(false)}
        onUpgrade={() => setShowModal(false)}
        proPlusProductId="pro-plus-annual"
        step="holiday"
        tierRequirement="intermediate_pro"
        user={user}
        visible={showModal}
        urls={urls}
      />
      <div styleName="holiday-banner" role="button" aria-label="Holiday banner" onClick={() => setShowModal(true)}>
        Tech the halls with our best prices of the season.
        {' '}<span styleName="cta">Get 23% off Pro.</span>
      </div>
    </>
  )
}

export default HolidayBanner
